import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as uuid from 'uuid';

@Injectable()
export class NavItemHelpService {
    readonly listId = <string>uuid.v4();
    readonly active$ = new BehaviorSubject<boolean>(false);
}
